import { Auditable } from '@models/auditable';
import { ndefault } from '@models/util';
import z from 'zod';

export type Role = z.infer<typeof Role>;

export const Role = Auditable.and(
  z.object({
    id: z.string(),
    orgId: z.string(),
    name: z.string(),
    claims: ndefault(z.array(z.string()), []),
  }),
);
